import range from 'lodash/range';

/**
 * First reference year considered for all paths (2020).
 *
 * NOTE-1: If this changes also the TemperatureTargetPath.length must be changed.
 * */
export const TARGET_PATH_FIRST_YEAR: ValidYear = 2020;

/**
 * Last reference year considered for all paths (2050).
 *
 * NOTE-1: If this changes also the TemperatureTargetPath.length must be changed.
 * */
export const TARGET_PATH_LAST_YEAR: ValidYear = 2050;

/**
 * Years for which we consider CO2 Emissions (2020 to 2050)
 * */
export const TARGET_PATH_YEARS_RANGE = range(TARGET_PATH_FIRST_YEAR, TARGET_PATH_LAST_YEAR + 1).map(
  (year) => year as ValidYear,
);

/**
 * Year for which we consider that the building is Paris-ready.
 */
export const PARIS_READY_YEAR = 2051;

/**
 * Date for which we consider that the building is Paris-ready.
 */
export const PARIS_READY_DATE = new Date(PARIS_READY_YEAR, 0, 1);

/**
 * Can't generate that automatically, so we need to hardcode itw.
 */
export type ValidYear =
  | 2020
  | 2021
  | 2022
  | 2023
  | 2024
  | 2025
  | 2026
  | 2027
  | 2028
  | 2029
  | 2030
  | 2031
  | 2032
  | 2033
  | 2034
  | 2035
  | 2036
  | 2037
  | 2038
  | 2039
  | 2040
  | 2041
  | 2042
  | 2043
  | 2044
  | 2045
  | 2046
  | 2047
  | 2048
  | 2049
  | 2050;

export function isValidYear(year: number): year is ValidYear {
  return year >= TARGET_PATH_FIRST_YEAR && year <= TARGET_PATH_LAST_YEAR;
}
